export default __webpack_public_path__ + "static/media/banner-alt.b714d0e4.png";